import React, { useContext, useEffect, useState, useRef } from "react";
import { getCorporateClient } from "../../../../Services/CorporateClient.service";
import { showAlert } from "../../../../Services/Shared.service";
import { Card, CardBody, Row } from "reactstrap";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import PackagesTableView from "../Tables/PackagesTableView";
import {
  Box,
  Button,
  IconButton,
  Tooltip,
  Typography,
  Skeleton,
  Tabs,
  Tab,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { getAvatarText } from "../../../../Services/Shared.service";
import { H4, H5, H6, P } from "../../../../AbstractElements";
import { getTaxGroupList } from "../../../../Services/Packages.service";
import EditNoteIcon from '@mui/icons-material/EditNote';
import CorporateClientInput from '../../../CorporateClient/CorporateClientInput'
import SharedDataContext from "../../../../_helper/SharedData";
import PackagesBulkCreate from "../../../FormsTariff/PackagesBulkCreate";
import TariffModal from "../../../../CommonElements/TariffModal/TariffModal";
// import NoteAddIcon from '@mui/icons-material/NoteAdd';
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Image } from "@mui/icons-material";
import editIcon from "../../../../assets/images/tarrifManagement/edit.png";
import DriverPayoutsTable from "../Tables/DriverPayoutsTable";
import DriverCreditsTable from "../Tables/DriverCreditsTable";
import { TABS_STYLE, TAB_ITEM_STYLE } from "../../../../styles/CommonStyles";
import { usePayoutAllowedCities } from "../../../../hooks/usePayoutAllowedCities";
// import Tooltip from '@mui/material/Tooltip';

function CorpClientInfo() {
  const { corpId } = useParams();
  const navigate = useNavigate();

  const {cityData,taxData} = useContext(SharedDataContext)
  const [corpObj, setCorpObj] = useState({});
  const [corpPackListData, setCorpPackListData] = useState([]);
  const [profileImage, setProfileImage] = useState("");
  const [isOpen,setIsOpen] = useState(false);
  const[isCreate,setIsCreate] = useState(false)
  const [isOpenEditClientModal, setIsOpenEditClientModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const closeWarningHandlerRef = useRef(null);
  const [activeTab, setActiveTab] = useState(0);

  const { isCityAllowed } = usePayoutAllowedCities(corpObj?.serviceCityId);
  const isPayoutAndCreditAvailable = isCityAllowed;

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleCloseModal = () => {
    if (closeWarningHandlerRef.current) {
      closeWarningHandlerRef.current();
    } else {
      setIsCreate(false);
    }
  };
 
  const refetchClientData = () => {
  setLoading(true);
  getCorporateClient(corpId)
    .then((resp) => {
      setCorpObj(resp.data);
    })
    .catch((err) => {
      showAlert("Can't able to fetch CorporateClient");
    })
    .finally(() => {
      setLoading(false);
    });
};

useEffect(() => {
  refetchClientData();
}, []);



  const handleBack = () => {
    navigate(-1);
  };

  const CityName = {
    1: "Delhi",
    8: "Amritsar",
    30: "Chennai",
    32: "Goa",
    4: "Bangalore",
  };



  return (
    <div
      style={{
        flex: "1",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "left",
        }}
      >
        <Button
          startIcon={<ArrowBackIosIcon />}
          sx={{
            color: "#41CC7D",
            marginBottom: 2,
          }}
          onClick={handleBack}
        >
          Back
        </Button>
      </div>

      <Card className="clientInfoCard">
        <CardBody
          style={{
            // color: "whitesmoke",
            backgroundColor: "rgba(20, 152, 38, 0.9)",
            borderRadius: "10px",
            boxShadow: `
      inset 0 0 8px white,
      inset 0 0 4px white
    `,
            borderRadius: "12px",
            padding: 2,
          }}
        >
          {loading ? (
            <Box sx={{ marginX: "20px", marginY: "0.75vw" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{ display: "flex", gap: "20px", alignItems: "center" }}
                >
                  <Skeleton
                    variant="text"
                    width="15vw"
                    height="2.5vw"
                    sx={{ bgcolor: "rgba(255, 255, 255, 0.2)" }}
                  />
                  <Skeleton
                    variant="rounded"
                    width="6.11vw"
                    height="2.01vw"
                    sx={{ bgcolor: "rgba(255, 255, 255, 0.2)" }}
                  />
                </Box>
                <Skeleton
                  variant="circular"
                  width="1.75vw"
                  height="1.75vw"
                  sx={{ bgcolor: "rgba(255, 255, 255, 0.2)" }}
                />
              </Box>
              <Box sx={{ width: "70%", marginTop: "30px" }}>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(4, 1fr)",
                    gap: "40px",
                  }}
                >
                  {[...Array(8)].map((_, index) => (
                    <Box key={index} sx={{ flex: 1 }}>
                      <Skeleton
                        variant="text"
                        width="80%"
                        height="1.2vw"
                        sx={{ bgcolor: "rgba(255, 255, 255, 0.2)" }}
                      />
                      <Skeleton
                        variant="text"
                        width="90%"
                        height="1.2vw"
                        sx={{ bgcolor: "rgba(255, 255, 255, 0.2)" }}
                      />
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          ) : (
            <Box sx={{ marginX: "20px", marginY: "0.75vw" }}>
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    // border: "1px solid red",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      width: "auto",
                      // border: "1px solid red",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "1.67vw",
                        color: "#ffffff",
                        fontWeight: "600",
                      }}
                    >
                      {corpObj.companyName}
                    </Typography>
                    {!corpObj.isDeleted ? (
                      <Box
                        sx={{
                          display: "flex",
                          backgroundColor: "#E3F5E1",
                          width: "6.11vw",
                          height: "2.01vw",
                          justifyContent: "space-evenly",
                          alignItems: "center",
                          borderRadius: "6px",
                          padding: "6px",
                          border: "2px solid rgba(116, 206, 106, 1)",
                          // height: "2.01vw",
                        }}
                      >
                        <Box
                          sx={{
                            width: "0.56vw",
                            height: "0.56vw",
                            background: "rgba(116, 206, 106, 1)",
                            borderRadius: "50%",
                          }}
                        />
                        <Typography sx={{ fontSize: "0.97vw" }}>
                          Active
                        </Typography>
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-around",
                          width: "6.11vw",
                          height: "2.01vw",
                          borderRadius: "6px",
                          padding: "6px",
                          backgroundColor: "#ffe5e5", // light red
                          border: "1px solid #cc0000", // darker red border
                        }}
                      >
                        <Box
                          sx={{
                            width: "0.56vw",
                            height: "0.56vw",
                            backgroundColor: "#cc0000",
                            borderRadius: "50%",
                          }}
                        />
                        <Typography
                          sx={{ fontSize: "0.97vw", color: "#cc0000" }}
                        >
                          InActive
                        </Typography>
                      </Box>
                    )}
                  </Box>
                  <Box>
                    <img
                      src={editIcon}
                      alt="edit"
                      style={{
                        width: "1.75vw",
                        height: "1.61vw",
                        cursor: "pointer",
                      }}
                      onClick={() => setIsOpenEditClientModal(true)}
                    />
                    <Tooltip title="Create Packages">
                      <IconButton
                        size="large"
                        onClick={() => {setIsCreate(true)
                          console.log("create package clicked")
                        }}
                      >
                        <AddCircleIcon
                          sx={{ color: "#FFFF", width: "2.08vw", height: "2.08vw" }}
                        />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Box>
              </Box>
              <Box sx={{ width: "70%", marginTop: "30px" }}>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(4, 1fr)",
                    gap: "40px",
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      Service City
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      {corpObj?.serviceCityName ? corpObj?.serviceCityName : "-"}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      Contact Person
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      {corpObj.contactPerson}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      Mobile No
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      {corpObj.mobile}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      Email
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      {corpObj.email}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      State
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      {corpObj.state}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      Client Type
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      {corpObj.isAirportClient ? "Airport" : "City"}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      Tax
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      {`Base Fare ${
                        corpObj.baseFareTaxPercentage ?? "-"
                      } Service Fare ${
                        corpObj.serviceFareTaxPercentage ?? "-"
                      }`}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      Address
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: "0.97vw",
                        color: "white",
                      }}
                    >
                      {corpObj.addressLine}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          )}
          {/* <div className="dsp-flx">
            <h1>{corpObj.companyName}</h1>
            <div>
            <Tooltip title="Create Packages">
              <IconButton  size="large" onClick={()=>setIsCreate(true)}>
                <AddCircleIcon sx={{color:"#FFFF",width:30,height:30}} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit Corporate Client">
              <IconButton  size="large" onClick={()=>setIsOpen(true)}>
                <EditNoteIcon sx={{color:"#FFFF",width:30,height:30}} />
              </IconButton>
            </Tooltip>
            </div>
          </div>
          <table
            // style={{
            //   width: "70%",
            // }}
          >
            <tr>
              <td>
                <td className="td-head">Name</td>
                <td className="td-dtls">{corpObj.companyName}</td>
              </td>
              <td>
                <td className="td-head">Client Type</td>
                <td className="td-dtls">
                  {corpObj.isAirportClient ? "Airport Client" : "City Client"}
                </td>
              </td>
            </tr>
            <tr>
              <td>
                <td className="td-head">Service City  </td>
                <td className="td-dtls">{CityName[corpObj.serviceCityId]}</td>
              </td>
              <td>
                <td className="td-head">Address </td>
                <td className="td-dtls">{corpObj.addressLine}</td>
              </td>
            </tr>
            <tr>
              <td>
                <td className="td-head">Contact Person </td>
                <td className="td-dtls">{corpObj.contactPerson}</td>
              </td>
              <td>
                <td className="td-head">City </td>
                <td className="td-dtls">{corpObj.city}</td>
              </td>
            </tr>
            <tr>
              <td>
                <td className="td-head">Moile Number </td>
                <td className="td-dtls">{corpObj.mobile}</td>
              </td>

              <td>
                <td className="td-head">State </td>
                <td className="td-dtls">{corpObj.state}</td>
              </td>
            </tr>
            <tr>
              <td>
                <td className="td-head">Email </td>
                <td className="td-dtls">{corpObj.email}</td>
              </td>
            </tr>
            <tr>
              <td>
                <td className="td-head">Tax </td>
                <td className="td-dtls">
                  {`Base ${corpObj?.baseFareTaxPercentage} Service ${corpObj?.serviceFareTaxPercentage}`}
                </td>
              </td>
            </tr>
          </table> */}
        </CardBody>
      </Card>

      {/*  */}
      <div>
        {isPayoutAndCreditAvailable ? (
          <Box sx={{ mt: 2 }}>
            <Tabs value={activeTab} onChange={handleTabChange} sx={TABS_STYLE}>
              <Tab label="Packages" sx={TAB_ITEM_STYLE} disableRipple />
              <Tab label="Driver Payouts" sx={TAB_ITEM_STYLE} disableRipple />
              <Tab label="Driver Credits" sx={TAB_ITEM_STYLE} disableRipple />
            </Tabs>

            {activeTab === 0 && <PackagesTableView corpId={corpId} />}
            {activeTab === 1 && (
              <DriverPayoutsTable
                corporateClientId={corpId}
                serviceCityId={corpObj?.serviceCityId}
              />
            )}
            {activeTab === 2 && (
              <DriverCreditsTable corporateClientId={corpId} />
            )}
          </Box>
        ) : (
          <PackagesTableView corpId={corpId} />
        )}
      </div>
      {/* the below component is used to edit a corporate client */}
      <CorporateClientInput
        cityData={cityData}
        editId={corpId}
        isOpen={isOpenEditClientModal}
        setIsOpen={setIsOpenEditClientModal}
        refetchClientData={refetchClientData}
      />

      {/* the below component is used to create a package for corporate client */}
      <TariffModal
        isOpen={isCreate}
        size="xl"
        centered
        toggler={handleCloseModal}
        title="Create Packages"
      >
        <PackagesBulkCreate
          handleCloseModal={() => setIsCreate(false)}
          corporateClientData={corpObj}
          registerCloseHandler={(handler) => {
            closeWarningHandlerRef.current = handler;
          }}
        />
      </TariffModal>
    </div>
  );
}

export default CorpClientInfo;
